<template>
  <div id="simple-calendar-app" class="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="taskList"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter calendar-heading">
			  <div class="vx-col  flex">
				  <h1>{{ $t('tasksCalendar') }}</h1>
			  </div>
            <!-- Current Month -->
            <div class="vx-col sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ datePeriod }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

<!--            <div class="vx-col sm:w-1/3 w-full flex justify-center">-->
<!--              <template v-for="(view, index) in calendarViewTypes">-->
<!--                <vs-button-->
<!--                  v-if="calendarView === view.val"-->
<!--                  :key="String(view.val) + 'filled'"-->
<!--                  type="filled"-->
<!--                  class="p-3 md:px-8 md:py-3"-->
<!--                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"-->
<!--                  @click="calendarView = view.val"-->
<!--                  >{{ view.label }}</vs-button>-->
<!--                <vs-button-->
<!--                  v-else-->
<!--                  :key="String(view.val) + 'border'"-->
<!--                  type="border"-->
<!--                  class="p-3 md:px-8 md:py-3"-->
<!--                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"-->
<!--                  @click="calendarView = view.val"-->
<!--                  >{{ view.label }}</vs-button>-->
<!--              </template>-->

<!--            </div>-->
          </div>
        </div>
      </calendar-view>
    </div>


  </div>
</template>

<script>
import CalendarView from '../v-calendar/CalendarView';
import CalendarViewHeader from '../v-calendar/CalendarViewHeader';
import date from "@/assets/configs/date.js";
require('../v-calendar/css/default.css')

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'
import moment from 'moment'

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  props: {
  	taskList: {
  		type: Array,
		default: () => []
	}
  },
  data () {
    return {
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      startDate: '',
      endDate: '',
      labelLocal: 'none',

      langHe: he,
      langEn: en,

      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: 'Month',
          val: 'month'
        },
        {
          label: 'Week',
          val: 'week'
        },
        {
          label: 'Year',
          val: 'year'
        }
      ]
    }
  },
  computed: {
  	datePeriod() {
		const dateMoment = moment(this.showDate);
		const month = this.$t(date.months[dateMoment.month()]);
		const year = dateMoment.format("YYYY");
		return `${month} ${year}`;
	},
    simpleCalendarEvents () {
      return this.$store.getters['calendar/getEvents']
    },
    validForm () {
      return this.title
		  !== '' && this.startDate
		  !== '' && this.endDate
		  !== '' && Date.parse(this.endDate) - Date.parse(this.startDate)
		  >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.calendar.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'business') return 'success'
        else if (label === 'work')     return 'warning'
        else if (label === 'personal') return 'danger'
        else if (label === 'none')     return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    // addEvent () {
    //   const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
    //   obj.classes = `event-${  this.labelColor(this.labelLocal)}`
	//
    //   this.$store.dispatch('calendar/addEvent', obj)
    // },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    clearFields () {
      this.title = this.endDate = this.url = ''
      this.id = 0
      this.labelLocal = 'none'
    },
    // promptAddNewEvent (date) {
    //   // this.disabledFrom = false
    //   // this.addNewEventDialog(date)
	// 	debugger;
	//
    // },
    // addNewEventDialog (date) {
    // 	debugger
    //   this.clearFields()
    //   this.startDate = date
    //   this.endDate = date
    //   this.activePromptAddEvent = true
    // },
    openAddNewEvent (date) {

		this.$emit('addTask', {date})
      // this.disabledFrom = true
      // this.addNewEventDialog(date)
    },
    openEditEvent (event) {
		this.$emit('editTask', event)
      // const e = this.$store.getters['calendar/getEvent'](event.id)
      // this.id = e.id
      // this.title = e.title
      // this.startDate = e.startDate
      // this.endDate = e.endDate
      // this.url = e.url
      // this.labelLocal = e.label
      // this.activePromptEditEvent = true
    },
    // editEvent () {
    //   const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
    //   obj.classes = `event-${  this.labelColor(this.labelLocal)}`
    //   this.$store.dispatch('calendar/editEvent', obj)
    // },
    // removeEvent () {
    //   this.$store.dispatch('calendar/removeEvent', this.id)
    // },
    eventDragged (event, date) {
      this.$store.dispatch('calendar/eventDragged', {event, date})
    }
  },
  created () {
    // this.$store.registerModule('calendar', moduleCalendar)
    // this.$store.dispatch('calendar/fetchEvents')
    // this.$store.dispatch('calendar/fetchEventLabels')
  },
  beforeDestroy () {
    // this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
@import "../../assets/scss/vuexy/variables.scss";

.simple-calendar-app {
	@media screen and (max-width: 1500px) {
		flex: 100% 0 0;
		margin-left: 0 !important;
		margin-top: 30px;
	}
	.vx-card {
		min-height: 600px;
	}
}

.calendar-heading{
	display: flex;
	justify-content: space-between;

}
.cv-event{
	background-color: $success !important;

	&.past{
		background-color: $danger !important;
	}
}
</style>`
